import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogContent, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    width: '50vh',
  },
});

function Loader({ showLoader }) {
  const classes = useStyles();
  return (
    <Dialog open={showLoader}>
      <DialogContent>
        <div className={classes.root}>
          <LinearProgress />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => ({
  showLoader: state.loader.show,
});

export default connect(mapStateToProps, null)(Loader);



// WEBPACK FOOTER //
// ./src/loader/Loader.js